import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/KebabHorizontal.svg'

export const IconKebabHorizontal = IconSVG as IconComponent
